<script setup lang="ts">
import {ConsumerProduct} from "@/consumer/interfaces";
import {DosagesTracker} from "@/interview/components/instance-modal/consumer-product-tracking/trackers";
import ObservanceTracker
    from "@/interview/components/instance-modal/consumer-product-tracking/trackers/ObservanceTracker.vue";
import AlertsTracker from "@/interview/components/instance-modal/consumer-product-tracking/trackers/AlertsTracker.vue";

defineProps<{
    products: ConsumerProduct[];
    consumerKey: string;
    girerd: { surveyId: number; latestInstance: Date | null };
    alertReview: {done: boolean; reviewDate: Date | null}
}>();

const emits = defineEmits<{
    (e: 'openDosageDialog'): void;
    (e: 'girerdClosed'): void;
    (e: 'openAlertsDialog'): void;
}>();
</script>

<template>
  <div class="bg-white p-4">
    <h2>Contrôlez les traitements du patient</h2>
    <div class="flex gap-4 flew-wrap">
      <DosagesTracker
        :consumer-key="consumerKey"
        :consumer-products="products"
        @open-dosage-dialog="emits('openDosageDialog')"
      />
      <ObservanceTracker
        :consumer-key="consumerKey"
        :girerd-id="girerd.surveyId"
        :latest-instance="girerd.latestInstance"
        :products="products"
        @survey-closed="emits('girerdClosed')"
      />
      <AlertsTracker
        :consumer-products="products"
        :done="alertReview.done"
        :date="alertReview.reviewDate"
        @open-alerts-dialog="$emit('openAlertsDialog')"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
